/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type OrgTypeAheadQueryVariables = Types.Exact<{
  country: Types.Scalars['String'];
  searchTerm: Types.Scalars['String'];
}>;


export type OrgTypeAheadQuery = { __typename: 'Query', orgs: Array<{ __typename: 'DnbOrg', dunsId: string, name: string, address: string }> };


export const OrgTypeAheadDocument = gql`
    query OrgTypeAhead($country: String!, $searchTerm: String!) {
  orgs: orgTypeAhead(country: $country, searchTerm: $searchTerm) {
    dunsId
    name
    address
  }
}
    `;

/**
 * __useOrgTypeAheadQuery__
 *
 * To run a query within a React component, call `useOrgTypeAheadQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgTypeAheadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgTypeAheadQuery({
 *   variables: {
 *      country: // value for 'country'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useOrgTypeAheadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrgTypeAheadQuery, OrgTypeAheadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgTypeAheadQuery, OrgTypeAheadQueryVariables>(OrgTypeAheadDocument, options);
      }
export function useOrgTypeAheadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgTypeAheadQuery, OrgTypeAheadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgTypeAheadQuery, OrgTypeAheadQueryVariables>(OrgTypeAheadDocument, options);
        }
export type OrgTypeAheadQueryHookResult = ReturnType<typeof useOrgTypeAheadQuery>;
export type OrgTypeAheadLazyQueryHookResult = ReturnType<typeof useOrgTypeAheadLazyQuery>;
export type OrgTypeAheadQueryResult = ApolloReactCommon.QueryResult<OrgTypeAheadQuery, OrgTypeAheadQueryVariables>;